module.exports = __webpack_public_path__ + "static/media/zcc.png.352d3672.crdownload";